<template>
  <div class="overview" v-loading="loading">
    <!-- 统计卡片 -->
    <el-row :gutter="20">
      <el-col :span="6">
        <el-card class="stat-card">
          <div class="stat-item">
            <div class="stat-value">{{ stats.totalCards }}</div>
            <div class="stat-label">总卡密数</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card">
          <div class="stat-item">
            <div class="stat-value">{{ stats.activeCards }}</div>
            <div class="stat-label">有效卡密</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card">
          <div class="stat-item">
            <div class="stat-value">{{ stats.onlineUsers }}</div>
            <div class="stat-label">在线用户</div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card">
          <div class="stat-item">
            <div class="stat-value">{{ stats.totalUsers }}</div>
            <div class="stat-label">总用户数</div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 最近验证日志 -->
    <el-card class="recent-logs" style="margin-top: 20px;">
      <template #header>
        <div class="card-header">
          <span>最近验证日志</span>
        </div>
      </template>
      <el-table :data="recentLogs" stripe>
        <el-table-column prop="username" label="用户" width="150" />
        <el-table-column prop="card_key" label="卡密" width="200" />
        <el-table-column prop="status" label="状态" width="100">
          <template #default="{ row }">
            <el-tag :type="row.status === 'success' ? 'success' : 'danger'">
              {{ row.status === 'success' ? '成功' : '失败' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="时间" />
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { ref, reactive, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'

export default {
  name: 'OverviewPage',
  setup() {
    const store = useStore()
    const router = useRouter()
    const loading = ref(false)
    
    const stats = reactive({
      totalCards: 0,
      activeCards: 0,
      onlineUsers: 0,
      totalUsers: 0
    })
    
    const recentLogs = ref([])
    
    const loadDashboardData = async () => {
      // 检查是否已经在加载中，避免重复请求
      if (loading.value) {
        return
      }
      
      loading.value = true
      try {
        // 检查token是否存在
        const token = localStorage.getItem('fanqianai_admin_token')
        if (!token) {
          console.warn('没有找到token，跳转到登录页')
          router.push('/login')
          return
        }
        
        // 获取卡密统计数据
        try {
          const cardStatsResponse = await store.dispatch('api/request', {
            url: '/api/cards/stats',
            method: 'GET'
          })
          
          if (cardStatsResponse && cardStatsResponse.success) {
            const cardStats = cardStatsResponse.data
            stats.totalCards = cardStats.overview.total || 0
            stats.activeCards = cardStats.overview.active || 0
          }
        } catch (error) {
          console.warn('获取卡密统计失败:', error)
        }
        
        // 获取代理商统计数据
        try {
          const agentStatsResponse = await store.dispatch('api/request', {
            url: '/api/agents/stats',
            method: 'GET'
          })
          
          if (agentStatsResponse && agentStatsResponse.success) {
            const agentStats = agentStatsResponse.data
            stats.totalUsers = agentStats.total || 0
          }
        } catch (error) {
          console.warn('获取代理商统计失败:', error)
        }
        
        // 获取系统状态数据
        try {
          const systemStatusResponse = await store.dispatch('api/request', {
            url: '/api/logs/system-status',
            method: 'GET'
          })
          
          if (systemStatusResponse && systemStatusResponse.success) {
            const systemStatus = systemStatusResponse.data
            stats.onlineUsers = systemStatus.online_devices || 0
          }
        } catch (error) {
          console.warn('获取系统状态失败:', error)
        }
        
        // 获取最近验证日志
        try {
          const logsResponse = await store.dispatch('api/request', {
            url: '/api/logs/verify?page=1&limit=5',
            method: 'GET'
          })
          
          if (logsResponse && logsResponse.success && logsResponse.data.logs) {
            recentLogs.value = logsResponse.data.logs.map(log => ({
              username: log.device_id || 'unknown',
              card_key: log.card_key ? log.card_key.replace(/(.{2})(.*)(.{4})/, '$1****$3') : 'unknown',
              status: log.verify_result === 'success' ? 'success' : 'failed',
              created_at: new Date(log.created_at).toLocaleString('zh-CN')
            }))
          } else {
            recentLogs.value = []
          }
        } catch (error) {
          console.warn('获取验证日志失败:', error)
          recentLogs.value = []
        }
        
      } catch (error) {
        console.error('加载数据失败:', error)
        // 如果是401错误，不显示错误消息，因为会自动跳转到登录页
        if (error.status !== 401) {
          ElMessage.error('加载数据失败，请刷新页面重试')
        }
        
        // 设置默认值
        stats.totalCards = 0
        stats.activeCards = 0
        stats.onlineUsers = 0
        stats.totalUsers = 0
        recentLogs.value = []
      } finally {
        loading.value = false
      }
    }
    
    onMounted(() => {
      // 页面加载时加载数据
      loadDashboardData()
    })
    
    return {
      loading,
      stats,
      recentLogs,
      loadDashboardData
    }
  }
}
</script>

<style lang="scss" scoped>
.overview {
  padding: 20px;
}

.stat-card {
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
}

.stat-item {
  padding: 20px;
}

.stat-value {
  font-size: 32px;
  font-weight: bold;
  color: #409eff;
  margin-bottom: 8px;
}

.stat-label {
  font-size: 14px;
  color: #666;
}

.recent-logs {
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
